module.exports = __webpack_public_path__ + "static/img/tab-car-none.9588d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/tab-car-none.png
// module id = LC36
// module chunks = 1